import { Component, OnInit } from '@angular/core';
import { TableSettingService, Column } from '@src/app/shared/services/table.setting.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';


@Component({
    selector: 'app-tables-columns-settings',
    templateUrl: './tables-columns-settings.component.html',
    styleUrls: ['./tables-columns-settings.component.scss'],
    host: {
        class: 'app-tables-columns-settings'
    },
    standalone: false
})
export class TablesColumnsSettingsComponent implements OnInit {

  TableSettingService = TableSettingService;
  columns: TableColumnsInternal[] = [];

  salesValues: string[] = [];
  retailsValues: string[] = [];
  warrantiesValues: string[] = [];
  codeOrdersValues: string[] = [];
  productsValues: string[] = [];
  itemsValues: string[] = [];
  inventoriesValues: string[] = [];
  shipmentsValues: string[] = [];
  customersValues: string[] = [];
  usersValues: string[] = [];
  categorieValues: string[] = [];
  cardOrdersValues: string[] = [];
  collectionsValues: string[] = [];
  distributionChannelsValues: string[] = [];
  exportsValues: string[] = [];
  importsValues: string[] = [];
  marketsValues: string[] = [];
  productAttributesValues: string[] = [];
  retailerAttributesValues: string[] = [];
  productTypesValues: string[] = [];
  retailerTypesValues: string[] = [];

  constructor(
    private tableSettingService: TableSettingService,
    private translate: TranslateService,
    private toasterService: ToasterService) { }

  async ngOnInit() {
    await this.tableSettingService.init();
    this.tableSettingService.initProducts();
    this.tableSettingService.initProductTypes();
    this.tableSettingService.initUsers();
    await this.tableSettingService.getAllTablesDefaultsSettings();
    this.setDefaultColumns(TableSettingService.SalesTableName);
    this.setDefaultColumns(TableSettingService.RetailsTableName);
    this.setDefaultColumns(TableSettingService.RetailerAttributeDefinitionsTableName);
    this.setDefaultColumns(TableSettingService.WarrantiesTableName);
    this.setDefaultColumns(TableSettingService.CodeOrdersTableName);
    this.setDefaultColumns(TableSettingService.ProductsTableName);
    this.setDefaultColumns(TableSettingService.ProductTypesTableName);
    this.setDefaultColumns(TableSettingService.ProductAttributeDefinitionsTableName);
    this.setDefaultColumns(TableSettingService.ItemsTableName);
    this.setDefaultColumns(TableSettingService.InventoriesTableName);
    this.setDefaultColumns(TableSettingService.ShipmentsTableName);
    this.setDefaultColumns(TableSettingService.CustomersTableName);
    this.setDefaultColumns(TableSettingService.UsersTableName);
    this.setDefaultColumns(TableSettingService.CategoriesTableName);
    this.setDefaultColumns(TableSettingService.CardOrdersTableName);
    this.setDefaultColumns(TableSettingService.CollectionsTableName);
    this.setDefaultColumns(TableSettingService.DistributionChannelsTableName);
    this.setDefaultColumns(TableSettingService.ExportsTableName);
    this.setDefaultColumns(TableSettingService.ImportsTableName);
    this.setDefaultColumns(TableSettingService.MarketsTableName);
    this.setDefaultColumns(TableSettingService.RetailerTypesTableName);
  }

  public getColumns(tableName: string): Column[] {
    return this.columns.find(x => x.key == tableName)?.columns ?? [];
  }

  private setDefaultColumns(tableName: string) {
    this.columns.push({ key: tableName, columns: this.tableSettingService.getTableSettings(tableName) });

    const values = this.tableSettingService.getTableDefaultsSettings(tableName);
    values.forEach(column => {
      if (!column.hide) {
        switch (tableName) {
          case TableSettingService.SalesTableName:
            this.salesValues.push(column.field);
            break;
          case TableSettingService.RetailsTableName:
            this.retailsValues.push(column.field);
            break;
          case TableSettingService.RetailerAttributeDefinitionsTableName:
            this.retailerAttributesValues.push(column.field);
            break;
          case TableSettingService.WarrantiesTableName:
            this.warrantiesValues.push(column.field);
            break;
          case TableSettingService.CodeOrdersTableName:
            this.codeOrdersValues.push(column.field);
            break;
          case TableSettingService.ProductsTableName:
            this.productsValues.push(column.field);
            break;
          case TableSettingService.ItemsTableName:
            this.itemsValues.push(column.field);
            break;
          case TableSettingService.InventoriesTableName:
            this.inventoriesValues.push(column.field);
            break;
          case TableSettingService.ShipmentsTableName:
            this.shipmentsValues.push(column.field);
            break;
          case TableSettingService.CustomersTableName:
            this.customersValues.push(column.field);
            break;
          case TableSettingService.UsersTableName:
            this.usersValues.push(column.field);
            break;
          case TableSettingService.CategoriesTableName:
            this.categorieValues.push(column.field);
            break;
          case TableSettingService.CardOrdersTableName:
            this.cardOrdersValues.push(column.field);
            break;
          case TableSettingService.CollectionsTableName:
            this.collectionsValues.push(column.field);
            break;
          case TableSettingService.DistributionChannelsTableName:
            this.distributionChannelsValues.push(column.field);
            break;
          case TableSettingService.ExportsTableName:
            this.exportsValues.push(column.field);
            break;
          case TableSettingService.ImportsTableName:
            this.importsValues.push(column.field);
            break;
          case TableSettingService.MarketsTableName:
            this.marketsValues.push(column.field);
            break;
          case TableSettingService.ProductAttributeDefinitionsTableName:
            this.productAttributesValues.push(column.field);
            break;
          case TableSettingService.ProductTypesTableName:
            this.productTypesValues.push(column.field);
            break;
          case TableSettingService.RetailerTypesTableName:
            this.retailerTypesValues.push(column.field);
            break;
        }
      }
    });
  }

  initForm() { }

  updateModulesSettings() {

    for (let index = 0; index < this.columns.length; index++) {
      const tableName = this.columns[index]?.key ?? '';
      const columns = this.columns[index]?.columns ?? [];

      columns.forEach(column => {
        switch (tableName) {
          case TableSettingService.SalesTableName:
            column.hide = this.salesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.RetailsTableName:
            column.hide = this.retailsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.RetailerAttributeDefinitionsTableName:
            column.hide = this.retailerAttributesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.WarrantiesTableName:
            column.hide = this.warrantiesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CodeOrdersTableName:
            column.hide = this.codeOrdersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ProductsTableName:
            column.hide = this.productsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ItemsTableName:
            column.hide = this.itemsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.InventoriesTableName:
            column.hide = this.inventoriesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ShipmentsTableName:
            column.hide = this.shipmentsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CustomersTableName:
            column.hide = this.customersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.UsersTableName:
            column.hide = this.usersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CategoriesTableName:
            column.hide = this.categorieValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CardOrdersTableName:
            column.hide = this.cardOrdersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CollectionsTableName:
            column.hide = this.collectionsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.DistributionChannelsTableName:
            column.hide = this.distributionChannelsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ExportsTableName:
            column.hide = this.exportsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ImportsTableName:
            column.hide = this.importsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.MarketsTableName:
            column.hide = this.marketsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ProductAttributeDefinitionsTableName:
            column.hide = this.productAttributesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ProductTypesTableName:
            column.hide = this.productTypesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.RetailerTypesTableName:
            column.hide = this.retailerTypesValues.find(v => v == column.field) == null;
            break;
        }
      });
      this.tableSettingService.saveTableSettings(tableName, columns);
    }

    const title = this.translate.instant('SYSTEM_SETTINGS.NOTIFICATIONS.TOAST_TITLE_SETTINGS_SAVED');
    const message = this.translate.instant('SYSTEM_SETTINGS.NOTIFICATIONS.TOAST_SUCCESS_MESSAGE_SETTINGS_SAVED');
    this.toasterService.show('success', title, message);
  }
}

export class TableColumnsInternal {
  key?: string;
  columns?: Column[]
}

export class ColumnsInternal {
  key?: string;
  columns?: string[];
}
